import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import MonthlyDisbursementPageUI from './MonthlyDisbursementPageUI.js'

class MonthlyDisbursementPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      monthlyDisbursedList: null,
      monthlyDisbursed: null,
      monthlyDisbursedIndex: 0
    }
  }

  render() {
    return (
      <MonthlyDisbursementPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        monthlyDisbursed={this.state.monthlyDisbursed}
        monthlyDisbursedList={this.state.monthlyDisbursedList}
        onRefreshClick={this.onRefreshClick}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        onTypeChange={this.onTypeChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDisbursementsMonthly(context, context.filter)
  }

  getDisbursementsMonthly(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/distributions/monthly`,
      cacheKey: CacheKeys.DisbursementsMonthly(stp),
      callback: this.getDisbursementsMonthlyCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getDisbursementsMonthlyCallback = (response) => {
    let mon = response.monthlyDisbursedList
    this.setState({
      errorList: response.errorList,
      monthlyDisbursed: mon[mon.length - 1],
      monthlyDisbursedIndex: mon.length - 1,
      monthlyDisbursedList: mon
    })
  }

  onPreviousClick = () => {
    let monthlyDisbursedIndex = this.state.monthlyDisbursedIndex - 1
    this.setState({
      monthlyDisbursedIndex: monthlyDisbursedIndex,
      monthlyDisbursed: this.state.monthlyDisbursedList[monthlyDisbursedIndex],
    })
  }

  onNextClick = () => {
    let monthlyDisbursedIndex = this.state.monthlyDisbursedIndex + 1
    this.setState({
      monthlyDisbursedIndex: monthlyDisbursedIndex,
      monthlyDisbursed: this.state.monthlyDisbursedList[monthlyDisbursedIndex],
    })
  }

  onTypeChange = (type) => {
    let context = this.props.context
    this.getDisbursementsMonthly(context, type)
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.DisbursementsMonthly(this.props.context.filter))
    this.setState({ monthlyDisbursedList: null, monthlyDisbursed: null, errorList: null }, () => {
      this.getDisbursementsMonthly(this.props.context, this.props.context.filter)
    })
  }

}

export default withRouter(MonthlyDisbursementPageSF)
